import { type FileCollection, fileCollectionSchema } from '@/types/file.ts'
import { apiClient } from '@/api/http.ts'

const FileApi = {
  async list(): Promise<FileCollection> {
    const response = await apiClient.get<unknown>(`/shared/list`)

    return fileCollectionSchema.parse(response.data)
  },
}
export default FileApi
